<template>
    <div class="nav-config">
        <el-radio-group v-model="navConfigData.navType" @change="handleNavTypeChange">
            <el-radio :label="NavTypeEnum.NoNavigation">无跳转</el-radio>
            <el-radio :label="NavTypeEnum.AppUI">应用界面</el-radio>
            <el-radio :label="NavTypeEnum.ExtLink">外部链接</el-radio>
        </el-radio-group>

        <div v-if="navConfigData.navType === NavTypeEnum.AppUI" class="nc-block">
            <div class="nc-row">
                <span class="nc-label">跳转目标</span>
                <el-select v-model="navConfig.appUI.appPage" class="nc-flex" @change="handleAppPageChange" filterable>
                    <el-option v-for="p in nativePages" :key="p.value" :label="p.label" :value="p.value" />
                </el-select>
            </div>

            <!-- 二级分类 -->
            <div v-if="navConfig.appUI.appPage === NavTargetEnum.SecondLevelCategory" class="nc-row nc-split">
                <div class="nc-half">
                    <span class="nc-label">一级分类</span>
                    <el-select v-model="firstCategoryValue" class="nc-flex" @change="handleResourceTypeChange"
                        filterable>
                        <el-option v-for="c in firstCategoryOptions" :key="c.value" :label="c.label" :value="c.value" />
                    </el-select>
                </div>
                <div v-if="firstCategoryValue" class="nc-half">
                    <span class="nc-label">二级分类</span>
                    <el-select v-model="secondCategoryValue" class="nc-flex" filterable>
                        <el-option v-for="c in secondCategoryOptions" :key="c.value" :label="c.label"
                            :value="c.value" />
                    </el-select>
                </div>
            </div>

            <!-- 资料/素材详情页 -->
            <div v-else-if="navConfig.appUI.appPage === NavTargetEnum.MaterialDetail" class="nc-row">
                <span class="nc-label">链接地址</span>
                <el-input v-model="materialDetail" class="nc-flex" />
            </div>

            <!-- 其他：跳转参数 key/value 列表 -->
            <div v-else class="nc-row">
                <span class="nc-label">跳转参数</span>
                <div class="nc-flex">
                    <div v-for="(kv, idx) in navConfig.appUI.args" :key="idx" class="kv-row">
                        <el-input v-model="kv.key" placeholder="key" size="small" class="kv-input" />
                        <el-input v-model="kv.value" placeholder="value" size="small" class="kv-input" />
                        <el-button type="text" size="mini" class="kv-del" @click="removeArg(idx)">删除</el-button>
                    </div>
                    <el-button type="text" size="mini" class="kv-add" @click="addArg">新增参数</el-button>
                </div>
            </div>
        </div>

        <div v-else-if="navConfigData.navType === NavTypeEnum.ExtLink" class="nc-block">
            <div class="nc-row">
                <span class="nc-label">原生链接</span>
                <el-input v-model="navConfig.extLink.nativeLink" class="nc-flex" />
            </div>
            <div class="nc-row">
                <span class="nc-label">网页链接</span>
                <el-input v-model="navConfig.extLink.webLink" class="nc-flex" />
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
import { valueByLanguage } from "@/utils/college";

// 复刻 galaxy 枚举值
const NavTypeEnum = {
    NoNavigation: 0,
    AppUI: 1,
    ExtLink: 2
};

const NavTargetEnum = {
    SecondLevelCategory: "SecondLevelCategory",
    MaterialDetail: "MaterialDetail",
    MemberCenter: "MemberCenter"
};

export default {
    name: "NavConfig",
    props: {
        // RESOURCE | MATERIAL（与 galaxy IndexModulesResourceTypeEnum 一致）
        type: {
            type: String,
            default: "RESOURCE"
        }
    },
    data() {
        return {
            NavTypeEnum,
            NavTargetEnum,
            nativePages: [
                { label: "二级分类页面", value: NavTargetEnum.SecondLevelCategory },
                { label: "资料/素材详情页", value: NavTargetEnum.MaterialDetail },
                { label: "会员中心", value: NavTargetEnum.MemberCenter }
            ],
            navConfigData: {
                navType: NavTypeEnum.NoNavigation,
                args: {}
            },
            navConfig: {
                appUI: {
                    appPage: NavTargetEnum.SecondLevelCategory,
                    args: []
                },
                extLink: {
                    nativeLink: "",
                    webLink: ""
                }
            },
            firstCategoryValue: "",
            secondCategoryValue: "",
            secondCategoryOptions: [],
            firstCategoryOptions: [],
            materialDetail: ""
        };
    },
    mounted() {
        if (this.navConfigData.navType === NavTypeEnum.AppUI) {
            this.getNativePagesData();
        }
        this.getFirstCategory();
    },
    methods: {
        async getNativePagesData() {
            try {
                const res = await api.getNativePages({ page: 1, pageSize: 2000, clientType: "galaxy" });
                const items = (res.data && res.data.items) ? res.data.items : [];
                const dynamicPages = items.map(({ key, value }) => ({ label: key, value }));
                this.nativePages = [
                    { label: "二级分类页面", value: NavTargetEnum.SecondLevelCategory },
                    { label: "资料/素材详情页", value: NavTargetEnum.MaterialDetail },
                    { label: "会员中心", value: NavTargetEnum.MemberCenter },
                    ...dynamicPages
                ];
            } catch (e) { }
        },
        handleNavTypeChange() {
            if (this.navConfigData.navType === NavTypeEnum.AppUI) {
                this.getNativePagesData();
            }
        },
        handleAppPageChange() {
            if (this.navConfig.appUI.appPage === NavTargetEnum.SecondLevelCategory) {
                this.firstCategoryValue = "";
                this.secondCategoryValue = "";
                this.secondCategoryOptions = [];
            } else if (this.navConfig.appUI.appPage === NavTargetEnum.MaterialDetail) {
                this.materialDetail = "";
            } else {
                this.navConfig.appUI.args = [{ key: "", value: "" }];
            }
        },
        async getFirstCategory() {
            // RESOURCE：模板/贴纸；MATERIAL：资料分类树
            if (this.type === "MATERIAL") {
                const res = await api.getMaterialCategoryTree({ page: 1, pageSize: 1000 });
                const items = (res.data && res.data.items) ? res.data.items : [];
                this.firstCategoryOptions = items.map((item) => ({
                    label: valueByLanguage(item.name, "zh_CN", true) || item.id,
                    value: item.id,
                    children: (item.children || []).map((c) => ({
                        label: valueByLanguage(c.name, "zh_CN", true) || c.id,
                        value: c.id
                    }))
                }));
            } else {
                this.firstCategoryOptions = [
                    { label: "模板", value: "TEMPLATE" },
                    { label: "贴纸", value: "STICKER" }
                ];
            }
        },
        async handleResourceTypeChange() {
            this.secondCategoryValue = "";
            this.secondCategoryOptions = [];
            await this.getSecondCategory();
        },
        async getSecondCategory() {
            if (!this.firstCategoryValue) return;
            if (this.type === "MATERIAL") {
                const found = this.firstCategoryOptions.find((x) => x.value === this.firstCategoryValue);
                this.secondCategoryOptions = found && found.children ? found.children : [];
                return;
            }
            const apiFn = this.firstCategoryValue === "TEMPLATE" ? api.getTemplateCategoryTree : api.getStickerCategoryTree;
            const res = await apiFn({ page: 1, pageSize: 1000 });
            const items = (res.data && res.data.items) ? res.data.items : [];
            this.secondCategoryOptions = items.map((item) => ({
                label: valueByLanguage(item.name, "zh_CN", true) || item.id,
                value: item.id
            }));
        },
        addArg() {
            this.navConfig.appUI.args.push({ key: "", value: "" });
        },
        removeArg(idx) {
            this.navConfig.appUI.args.splice(idx, 1);
        },
        // ===== expose（与 galaxy 一致）=====
        getData() {
            const type = this.navConfigData.navType;
            if (type === NavTypeEnum.NoNavigation) {
                return { navType: NavTypeEnum.NoNavigation, args: {} };
            }
            if (type === NavTypeEnum.ExtLink) {
                return {
                    navType: NavTypeEnum.ExtLink,
                    nativeLink: this.navConfig.extLink.nativeLink,
                    webLink: this.navConfig.extLink.webLink,
                    args: {}
                };
            }

            // AppUI
            const appPage = this.navConfig.appUI.appPage;
            let args = {};
            if (appPage === NavTargetEnum.SecondLevelCategory) {
                if (this.type === "MATERIAL") {
                    args = {
                        // 资料中心：这里简化成 categoryId（完全对齐 galaxy 的 categoryIds 可在后续补齐）
                        categoryId: this.secondCategoryValue || this.firstCategoryValue,
                        resourceType: "MATERIAL"
                    };
                } else {
                    args = {
                        resourceType: this.firstCategoryValue,
                        categoryId: this.secondCategoryValue || this.firstCategoryValue
                    };
                }
            } else if (appPage === NavTargetEnum.MaterialDetail) {
                try {
                    const params = new URL(this.materialDetail).searchParams;
                    args = {
                        url: this.materialDetail,
                        uniqueId: params.get("id"),
                        type: params.get("type")
                    };
                } catch (e) {
                    args = { url: this.materialDetail };
                }
            } else {
                (this.navConfig.appUI.args || []).forEach((kv) => {
                    if (kv.key && kv.value) args[kv.key] = kv.value;
                });
            }

            return { navType: NavTypeEnum.AppUI, appPage, args };
        },
        async initData(details) {
            if (!details) return;
            this.navConfigData = { ...details };
            if (details.navType === NavTypeEnum.AppUI) {
                await this.getNativePagesData();
                this.navConfig.appUI.appPage = details.appPage || NavTargetEnum.SecondLevelCategory;
                if (this.navConfig.appUI.appPage === NavTargetEnum.SecondLevelCategory) {
                    await this.getFirstCategory();
                    if (this.type === "MATERIAL") {
                        this.firstCategoryValue = details.args && (details.args.categoryId || "");
                        await this.getSecondCategory();
                    } else {
                        this.firstCategoryValue = details.args && (details.args.resourceType || "");
                        await this.getSecondCategory();
                        this.secondCategoryValue = details.args && (details.args.categoryId || "");
                    }
                } else if (this.navConfig.appUI.appPage === NavTargetEnum.MaterialDetail) {
                    this.materialDetail = details.args && details.args.url;
                } else {
                    const args = details.args || {};
                    this.navConfig.appUI.args = Object.keys(args).map((k) => ({ key: k, value: args[k] }));
                    if (!this.navConfig.appUI.args.length) this.navConfig.appUI.args = [{ key: "", value: "" }];
                }
            } else if (details.navType === NavTypeEnum.ExtLink) {
                this.navConfig.extLink.nativeLink = details.nativeLink || "";
                this.navConfig.extLink.webLink = details.webLink || "";
            }
        }
    }
};
</script>

<style scoped>
.nav-config {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.nc-block {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.nc-row {
    display: flex;
    gap: 10px;
    align-items: center;
}

.nc-label {
    width: 70px;
    flex-shrink: 0;
    color: #606266;
}

.nc-flex {
    flex: 1;
    min-width: 0;
}

.nc-split {
    justify-content: space-between;
}

.nc-half {
    width: 49%;
    display: flex;
    align-items: center;
    gap: 10px;
}

.kv-row {
    display: flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 6px;
}

.kv-input {
    width: 200px;
}

.kv-add {
    color: #67c23a;
}

.kv-del {
    color: #f56c6c;
}
</style>
